export const demoComments = [
  {
    id: "c1",
    user: "光影拾遗",
    date: "2026-02-20",
    content: "节奏把控得很好，看着看着就忘了时间。演员的表演特别有说服力，几个长镜头很有味道。",
    likes: 128
  },
  {
    id: "c2",
    user: "追剧的小林",
    date: "2026-02-18",
    content: "整体质感在线，细节也经得起推敲。虽然有些地方略显克制，但正是这种克制让人回味。",
    likes: 86
  },
  {
    id: "c3",
    user: "南方有风",
    date: "2026-02-15",
    content: "冲着题材来的，没想到比预期还好。人物的动机交代得很清楚，看完之后还意犹未尽。",
    likes: 54
  }
];